var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Amplify } from 'aws-amplify';
import { confirmSignIn, fetchAuthSession, getCurrentUser, signOut, fetchUserAttributes, sendUserAttributeVerificationCode, confirmUserAttribute, updateUserAttribute } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
Amplify.configure({
    Auth: {
        Cognito: {
            //  Amazon Cognito User Pool ID
            userPoolId: process.env.AWS_COGNITO_USER_POOL_ID,
            // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
            userPoolClientId: process.env.AWS_COGNITO_WEB_AGENT_CLIENT_ID,
            // REQUIRED only for Federated Authentication - Amazon Cognito Identity Pool ID
            // identityPoolId: 'XX-XXXX-X:XXXXXXXX-XXXX-1234-abcd-1234567890ab',
            identityPoolId: null,
            // OPTIONAL - Set to true to use your identity pool's unauthenticated role when user is not logged in
            allowGuestAccess: false,
            // OPTIONAL - This is used when autoSignIn is enabled for Auth.signUp
            // 'code' is used for Auth.confirmSignUp, 'link' is used for email link verification
            signUpVerificationMethod: 'code', // 'code' | 'link'
        },
    }
});
Hub.listen('auth', function (_a) {
    var payload = _a.payload;
    console.log(payload);
    switch (payload.event) {
        case 'signedIn':
            console.log('user have been signedIn successfully.');
            break;
        case 'signedOut':
            console.log('user have been signedOut successfully.');
            var searchParams = new URLSearchParams(window.location.search);
            var code = searchParams.get('session_ended_code');
            if (!code) {
                var serverSideLogOutUrl = "/users/logout";
                window.location.replace(serverSideLogOutUrl);
            }
            break;
        case 'tokenRefresh':
            console.log('auth tokens have been refreshed.');
            // alert('auth tokens have been refreshed.');
            break;
        case 'tokenRefresh_failure':
            console.log('failure while refreshing auth tokens.');
            // alert('failure while refreshing auth tokens.');
            break;
        case 'signInWithRedirect':
            console.log('signInWithRedirect API has successfully been resolved.');
            break;
        case 'signInWithRedirect_failure':
            console.log('failure while trying to resolve signInWithRedirect API.');
            break;
        case 'customOAuthState':
            console.info('custom state returned from CognitoHosted UI');
            break;
    }
});
import * as Amplify_1 from 'aws-amplify';
export { Amplify_1 as Amplify };
import * as auth_1 from 'aws-amplify/auth';
export { auth_1 as auth };
/**
 * Documentation: https://docs.amplify.aws/gen1/react/build-a-backend/auth/manage-user-session/
 * The fetchAuthSession API automatically refreshes the user's session when the authentication tokens have expired and
 * a valid refreshToken is present. Additionally, you can also refresh the session explicitly by calling the
 * fetchAuthSession API with the forceRefresh flag enabled.
 */
export function getSignedInUser() {
    return __awaiter(this, arguments, void 0, function (signOutOnError) {
        var currentUser, session, refreshToken, err_1;
        if (signOutOnError === void 0) { signOutOnError = false; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 7]);
                    return [4 /*yield*/, getCurrentUser()];
                case 1:
                    currentUser = _a.sent();
                    console.log('current user', currentUser);
                    return [4 /*yield*/, fetchAuthSession({ forceRefresh: false })];
                case 2:
                    session = _a.sent();
                    console.log('session', session);
                    refreshToken = getRefreshTokenFromLocalStorage();
                    return [2 /*return*/, {
                            username: currentUser.username,
                            userId: currentUser.userId,
                            session: session,
                            accessToken: session.tokens.accessToken,
                            refreshToken: refreshToken,
                            idToken: session.tokens.idToken,
                            deviceKey: session.tokens.accessToken.payload.device_key,
                        }];
                case 3:
                    err_1 = _a.sent();
                    console.log('getSignedInUser error', err_1);
                    if (!signOutOnError) return [3 /*break*/, 5];
                    return [4 /*yield*/, signOut()];
                case 4:
                    _a.sent();
                    return [3 /*break*/, 6];
                case 5: return [2 /*return*/, null];
                case 6: return [3 /*break*/, 7];
                case 7: return [2 /*return*/];
            }
        });
    });
}
export function signOutUser() {
    return __awaiter(this, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, signOut()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    err_2 = _a.sent();
                    console.log(err_2);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function handleMFASelection(mfaType) {
    return __awaiter(this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.log('MFA Type', mfaType);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, confirmSignIn({ challengeResponse: mfaType })];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function sendChallengeResponse(response) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, confirmSignIn({
                        challengeResponse: response,
                        options: {
                            clientMetadata: {
                                platform: 'web',
                            }
                        }
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
/**
 * Returns an array with two possible elements: 'email' or/and 'phone'.
 * An empty array means there is no delivery methods configured.
 */
export function gteVerifiedMFATypes() {
    return __awaiter(this, void 0, void 0, function () {
        var verifiedMFATypes, userAttributes, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    verifiedMFATypes = [];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getUserAttributes()];
                case 2:
                    userAttributes = _a.sent();
                    if ('email_verified' in userAttributes) {
                        if (userAttributes.email_verified === "true") {
                            verifiedMFATypes.push('email');
                        }
                    }
                    if ('phone_number_verified' in userAttributes) {
                        if (userAttributes.phone_number_verified === "true") {
                            verifiedMFATypes.push('phone');
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.log(error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, verifiedMFATypes];
            }
        });
    });
}
export function getUserAttributes() {
    return __awaiter(this, void 0, void 0, function () {
        var userAttributes;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchUserAttributes()];
                case 1:
                    userAttributes = _a.sent();
                    return [2 /*return*/, userAttributes];
            }
        });
    });
}
/**
 * @param attributeName 'email' | 'phone_number'
 */
export function sendVerificationCode(attributeName) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (attributeName !== 'email' && attributeName !== 'phone_number') {
                        throw new Error("Attribute must be email or a phone_number.");
                    }
                    return [4 /*yield*/, sendUserAttributeVerificationCode({ userAttributeKey: attributeName })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
/**
 *
 * @param userAttributeKey 'email' | 'phone_number'
 * @param confirmationCode
 */
export function confirmAttribute(userAttributeKey, confirmationCode) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (userAttributeKey !== 'email' && userAttributeKey !== 'phone_number') {
                        throw new Error("Attribute must be email or a phone_number.");
                    }
                    confirmationCode = confirmationCode.trim();
                    if (confirmationCode === "") {
                        throw new Error("Code cannot be empty.");
                    }
                    return [4 /*yield*/, confirmUserAttribute({ userAttributeKey: userAttributeKey, confirmationCode: confirmationCode })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
export function updateAttribute(attributeName, attributeValue) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateUserAttribute({
                        userAttribute: {
                            attributeKey: attributeName,
                            value: attributeValue
                        }
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function getRefreshTokenFromLocalStorage() {
    var lastUserKey = "CognitoIdentityServiceProvider.".concat(process.env.AWS_COGNITO_WEB_AGENT_CLIENT_ID, ".LastAuthUser");
    var lastUser = localStorage.getItem(lastUserKey);
    var refreshTokenKey = "CognitoIdentityServiceProvider.".concat(process.env.AWS_COGNITO_WEB_AGENT_CLIENT_ID, ".").concat(lastUser, ".refreshToken");
    return localStorage.getItem(refreshTokenKey);
}
